import { render, staticRenderFns } from "./ClickToEditImage.vue?vue&type=template&id=159021cf"
import script from "./ClickToEditImage.vue?vue&type=script&lang=js"
export * from "./ClickToEditImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports